export class AccConstants {
    static readonly ITEM_NOTES = 'Item Notes';
    static readonly PROJECT_NOTES = 'Project Notes';
    static readonly ITEM_LOGS = 'Item Logs';
    static readonly PROJECT_LOGS = 'Project Logs';

    static readonly VIEW_EDIT = 'viewEdit';
    static readonly CHANGE_STATUS = 'changeStatus';
    static readonly CHANGE_OWNER = 'changeOwner';
    static readonly EMAIL_REMINDER = 'emailReminder';
    static readonly ARCHITECTURAL_BOARD_APPROVAL = 'architecturalBoardApproval';
    static readonly EMAIL_OWNER = 'emailOwner';
    static readonly FINALIZE = 'finalize';
    static readonly UNFINALIZE = 'unfinalize';
    static readonly VIEW = 'view';
    static readonly CUSTOM_RESPONSES = 'customResponses';

    static readonly BOARD_COMMITTEE_MEMBERS = 'boardOrCommitteeMembers';
    static readonly SERVICE_TEAM = 'serviceTeam';
    static readonly EDIT = 'edit';
    static readonly REMOVE = 'remove';
}
